import { useEffect } from "react";
import { trackPageView } from "./";

const useTrackPageView = (stepId = "") =>
  useEffect(() => {
    if (window && window.location) {
      trackPageView(window.location.href);
    }
  }, [stepId]);

export { useTrackPageView };
